import React from 'react';

const AssessmentsPage: React.FC = () => {
  return (
    <div className="blank" style={{ display: 'grid', placeItems: 'center' }}>
      this is assesments
    </div>
  );
};

export default AssessmentsPage;




